import React from "react"

import { SEO, Section } from "../components"
import { DefaultLayout } from "../layouts"

const NotFoundPage = () => (
  <DefaultLayout>
    <SEO title="404" />
    <Section>
      
    </Section>
  </DefaultLayout>
)

export default NotFoundPage
